import { render, staticRenderFns } from "./sub_homework_detail.vue?vue&type=template&id=62fc9e73&scoped=true"
import script from "./sub_homework_detail.vue?vue&type=script&lang=js"
export * from "./sub_homework_detail.vue?vue&type=script&lang=js"
import style0 from "./sub_homework_detail.vue?vue&type=style&index=0&id=62fc9e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc9e73",
  null
  
)

export default component.exports